import { useState, useEffect } from "react";
import { Menu, X } from "lucide-react";
import Logo from "@/components/landing/Logo";
import { SITE, waLink } from "@/lib/siteConfig";

const NAV_LINKS = [
  { label: "Services", href: "#services" },
  { label: "Spare Parts", href: "#parts" },
  { label: "Jual & Beli", href: "#buysell" },
  { label: "About", href: "#about" },
  { label: "Location", href: "#location" },
];

export default function Header() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all ${
        scrolled ? "header-glass" : "bg-white"
      }`}
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 h-16 flex items-center justify-between">
        <a
          href="#top"
          className="flex items-center gap-2.5"
          data-testid="logo-link"
        >
          <Logo className="h-10 w-10" />
          <div className="flex flex-col leading-none">
            <span className="font-display text-xl font-black tracking-tighter">
              {SITE.name}
            </span>
            <span className="font-mono-ez text-[9px] tracking-widest uppercase text-[#525252] mt-0.5">
              We make it <span className="text-[#FF3333]">e</span>a<span className="text-[#FF6B00]">z</span>y
            </span>
          </div>
        </a>

        <nav className="hidden md:flex items-center gap-8">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="link-underline text-sm font-medium text-[#0A0A0A]"
              data-testid={`nav-${l.label.toLowerCase().trim().replace(/[\s&]+/g, "-")}`}
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <a
            href={waLink(SITE.waMessages.bookRepair)}
            target="_blank"
            rel="noopener noreferrer"
            className="btn-ez btn-ez-primary"
            data-testid="header-book-repair-btn"
          >
            Book Repair →
          </a>
        </div>

        <button
          className="md:hidden p-2"
          onClick={() => setOpen(!open)}
          data-testid="mobile-menu-toggle"
          aria-label="Toggle menu"
        >
          {open ? <X /> : <Menu />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-white border-t border-[#E5E5E5]" data-testid="mobile-menu">
          <div className="px-6 py-4 flex flex-col gap-4">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-base font-medium"
                data-testid={`mobile-nav-${l.label.toLowerCase().trim().replace(/[\s&]+/g, "-")}`}
              >
                {l.label}
              </a>
            ))}
            <a
              href={waLink(SITE.waMessages.bookRepair)}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-ez btn-ez-primary w-full justify-center"
              data-testid="mobile-book-repair-btn"
            >
              Book Repair →
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
